<div class="link-logout d-flex align-items-center">
  <ng-container *ngIf="logoutOnly(); else loginStatus">
    <ng-container *ngIf="user$ | async as user; else notLoggedIn">
      <a routerLink="/logout" data-testing-id="link-logout" aria-label="logout">
        <i class="icon-users"></i>
        <span *ngIf="view() !== 'small'"> {{ 'account.logout.link' | translate }} </span>
      </a>
    </ng-container>
    <ng-template #notLoggedIn />
  </ng-container>
  <ng-template #loginStatus>
    <!-- logged in -->

    <ng-container *ngIf="user$ | async as user; else notLoggedIn">
      <a routerLink="/account" class="my-account-link user-name" data-testing-id="link-myaccount" aria-label="account">
        <i class="icon-users"></i>
        <div class="login-name" [ngClass]="getViewClasses()">
          <span *ngIf="user.lastName; else nameNotDisplayed">{{ user.firstName + ' ' + user.lastName }}</span>
          <ng-template #nameNotDisplayed>
            <span class="login-name" [ngClass]="getViewClasses()">{{
              'account.login_status.myaccount.link' | translate
            }}</span></ng-template
          >
        </div>
      </a>

      <!-- We hide the sales rep functionality in the dotcms edit view.
      TODO: We have to work on this after getting customer segment feature in  the dotcms -->

      <div *ngIf="(deviceType$ | async) === 'desktop' && !isInsideIframe" class="w-100">
        <custom-lazy-sales-rep-users-list />
      </div>
      <span class="separator" [ngClass]="getViewClasses()">/</span>
      <a
        routerLink="/logout"
        class="my-account-link my-account-logout"
        data-testing-id="link-logout"
        aria-label="logout"
      >
        <span [ngClass]="getViewClasses()">{{ 'account.logout.link' | translate }}</span>
      </a>
    </ng-container>

    <!-- not logged in -->
    <ng-template #notLoggedIn>
      <ng-container *ngIf="showLink$ | async; else empty">
        <a
          routerLink="/login"
          [queryParams]="{ returnUrl: '/account' }"
          class="my-account-link my-account-login"
          rel="nofollow"
          aria-label="login"
          (click)="resetActiveIdp()"
        >
          <i class="icon-users"></i>
          <span [ngClass]="getViewClasses()">{{ 'account.login.link' | translate }}</span>
        </a>
        <span class="separator" [ngClass]="getViewClasses()">/</span
        ><a
          routerLink="/register"
          [queryParams]="{ returnUrl: '/account' }"
          class="my-account-link my-account-register"
          rel="nofollow"
          aria-label="register"
          (click)="resetActiveIdp()"
          ><span [ngClass]="getViewClasses()">{{ 'account.register.link' | translate }}</span>
        </a>
      </ng-container>

      <ng-template #empty />
    </ng-template>
  </ng-template>
</div>
